import React from "react";
import T from "prop-types";

import Buttons, { ButtonsSet } from "2g-buttons";
import Form, { Field, Inputs, Row, ActionButton } from "2g-form";
import Widget from "2g-widget";
import { required } from "2g-validators-common";

import useMessages from "./i18n/useMessages";
import useProjektVytvoreni from "./useProjektVytvoreni";
import { ACZakaznikSmlouvy } from "b2b/components/autocompletes";
import { useServerMessage } from "b2b/i18n";

const requiredValidator = required();

export function ProjektVytvoreni({ zakaznik }) {
  const {
    titleVytvoreni,
    titleEdit,
    buttonSubmitVytvoreni,
    buttonSubmitEdit,
    buttonCancel
  } = useMessages();
  const message = useServerMessage();
  const { formModuleKey, onSubmit, onCancel, isEdit, loader } =
    useProjektVytvoreni({
      zakaznik
    });
  return (
    <Widget
      title={
        isEdit
          ? `${titleEdit()}: ${message(loader.data, "nazev") || ""}`
          : titleVytvoreni()
      }
      collapsable={false}
    >
      <Form
        moduleKey={formModuleKey}
        onSubmit={onSubmit}
        disabled={loader.loading || loader.error}
      >
        <Row styled>
          <Field
            component={Inputs.Input}
            path="nazevCs"
            label="b2b.projekt-vytvoreni.field.nazev.label"
            validators={requiredValidator}
            required
          />
          <Field
            component={Inputs.Input}
            path="nazevEn"
            label="b2b.projekt-vytvoreni.field.nazevEn.label"
            validators={requiredValidator}
            required
          />
        </Row>
        <Row styled>
          <Field
            component={Inputs.Input}
            path="popisCs"
            label="b2b.projekt-vytvoreni.field.popis.label"
          />
          <Field
            component={Inputs.Input}
            path="popisEn"
            label="b2b.projekt-vytvoreni.field.popisEn.label"
          />
        </Row>
        <Row styled>
          <ACZakaznikSmlouvy
            path="smlouva"
            zakaznikICO={zakaznik?.ico}
            validators={requiredValidator}
            required
          />
        </Row>
        <ButtonsSet>
          <ActionButton button={Buttons.Primary} validate submit inverse>
            {isEdit ? buttonSubmitEdit() : buttonSubmitVytvoreni()}
          </ActionButton>
          <ActionButton button={Buttons.Default} onClick={onCancel}>
            {buttonCancel()}
          </ActionButton>
        </ButtonsSet>
      </Form>
    </Widget>
  );
}

ProjektVytvoreni.propTypes = { zakaznik: T.object };

export default React.memo(ProjektVytvoreni);
